import { request, sleep } from 'beans-admin-plugin';
import OSS from 'ali-oss';
import _ from 'lodash';
import urlJoin from 'url-join';
import moment from 'moment';

function createUploadResult(directUploadResult) {
  return {
    ...directUploadResult,
    url: directUploadResult.direct_upload.url,
    blob_url: directUploadResult.direct_upload.blob_url
  };
}

export async function commonUpload(file, directUploadResult = {}, { onProgress = _.noop } = {}) {
  onProgress(0);
  const uploadTask = request.put(directUploadResult.direct_upload.url, file.slice(), { headers: directUploadResult.direct_upload.headers, timeout: 1 * 60 * 60 * 1000 });
  uploadTask.engine.upload.onprogress = ({ total, loaded }) => onProgress(Math.floor(loaded / total * 100));
  await uploadTask;
}

// 阿里云分片上传，断点续传
export async function stsUpload(file, directUploadResult = {}, { onProgress = _.noop, options = {}, headers = {} } = {}) {
  onProgress(0);
  const defaultPageSize = 1024 * 1024 * 50; // 50Mb
  if (directUploadResult.byte_size < defaultPageSize) {
    return commonUpload(file, directUploadResult, { onProgress });
  }
  const maxRetryTimes = 5;
  let uploadCheckPoint;
  let retryTimes = 0;
  let client = new OSS({
    region: directUploadResult.region,
    bucket: directUploadResult.bucket,
    accessKeyId: directUploadResult.sts.access_key_id,
    accessKeySecret: directUploadResult.sts.access_key_secret,
    stsToken: directUploadResult.sts.security_token
  });
  let tokenExpiration = directUploadResult.sts.expiration; // token过期时间

  const refreshClient = async () => {
    // 刷新token
    const { expiration, security_token, access_key_id, access_key_secret } = await request.get('/active_storage/sts');
    tokenExpiration = expiration;
    client = new OSS({
      region: directUploadResult.region,
      bucket: directUploadResult.bucket,
      accessKeyId: access_key_id,
      accessKeySecret: access_key_secret,
      stsToken: security_token
    });
  };
  // 判断是否只剩60s过期
  const checkIsTokenWillExpired = () => moment(tokenExpiration).diff(moment(), 'seconds') < 60;

  const upload = async () => {
    const uploadOptions = {
      progress(p, checkpoint) {
        onProgress(Math.floor(p * 100));
        // 记录当前checkpoint
        uploadCheckPoint = checkpoint;
        if (checkIsTokenWillExpired()) {
          client.cancel();
        }
      },
      checkpoint: uploadCheckPoint,
      // 分片数量。
      parallel: 4,
      // 分片大小
      partSize: defaultPageSize,
      headers: {
        ...headers
      },
      timeout: 30 * 60 * 60 * 1000,
      ...options,
    };
    try {
      await client.multipartUpload(urlJoin(directUploadResult.path, directUploadResult.key), file, uploadOptions);
      uploadCheckPoint = null;
    } catch (e) {
      if (checkIsTokenWillExpired()) {
        // 刷新token
        await refreshClient();
      }
      retryTimes++;
      if (retryTimes >= maxRetryTimes) {
        throw new Error(`Upload failed - ${e.message || ''}`);
      }
      await sleep(Math.pow(2, retryTimes) * 1000);
      return upload();
    }
  }
  return upload();
}

export default async function upload(file, directUploadOptions = {}, { onProgress = _.noop, options = {}, headers = {} } = {}) {
  const directUploadResult = await request.post('/active_storage/direct_upload', directUploadOptions);
  if (directUploadResult.sts) {
    await stsUpload(file, directUploadResult, { onProgress, options, headers });
  } else {
    await commonUpload(file, directUploadResult, { onProgress, options, headers });
  }
  return createUploadResult(directUploadResult);
}
